import "devextreme/dist/css/dx.common.css";
import "./themes/generated/theme.base.css";
import "./themes/generated/theme.additional.css";
import React from "react";
import { HashRouter as Router } from "react-router-dom";
import "./dx-styles.scss";
import LoadPanel from "devextreme-react/load-panel";
import { NavigationProvider } from "./contexts/navigation";
import { AuthProvider, useAuth } from "./contexts/auth";
import { useScreenSizeClass } from "./utils/media-query";
import Content from "./Content";
import UnauthenticatedContent from "./UnauthenticatedContent";
import config from "devextreme/core/config";
import { EnvironmentIndicator } from "./components";

function App() {
  config({
  animation: {
    enabled: false
  }
});
  const { user, loading } = useAuth();
  try {
    if (loading) {
      return <LoadPanel visible={true} />;
    }

    config({
      rtlEnabled: user.formDirection, //set the direction of the form by company settings form server
      forceIsoDateParsing: true,

      // ...
    });
    if (user) {
      return <Content data={user} />;
    }
  } catch (error) {
    return <UnauthenticatedContent />;
  }
  return <UnauthenticatedContent />;
}

export default function () {
  const screenSizeClass = useScreenSizeClass();

  return (
    <Router>
      <AuthProvider>
        <NavigationProvider>
          <div className={`app ${screenSizeClass}`}>
            <App />
            <EnvironmentIndicator />
          </div>
        </NavigationProvider>
      </AuthProvider>
    </Router>
  );
}
// Production deploy v3 - API path fix - 2026-06-03
